import { faArrowsRotate, faSlidersSimple } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import "./ColumnSelector.scss";
import { IDropdownItem } from "../../dropdown/dropdownUtils";
import Dropdown from "../../dropdown/Dropdown";
import Button from "../../button/Button";


interface IProps {
    minimumNumberOfActions?: number;
    columns: { [name: string]: boolean };
    order?: string[];
    onColumnSelectorChange?(columns: { [name: string]: boolean }): void;
    onResetColumns?(): void;
    onResetOrder?(): void;
    onResetSizes?(): void;
    onResetSort?(): void;
    onResetAll?(): void;
}

export default function ColumnSelector(props: IProps) {
    const { t } = useTranslation();
    const orderedKeys =
        Array.isArray(props.order) && props.order.length > 0
            ? [
                  ...props.order.filter((key) => key in props.columns),
                  ...Object.keys(props.columns).filter((key) => !(props.order || []).includes(key)),
              ]
            : Object.keys(props.columns);

    const dropdownItems: IDropdownItem[] = useMemo(() => {
        const items: IDropdownItem[] = orderedKeys.map((key, index) => ({
            id: key,
            title: key,
            options: "checkbox",
            value: !!props.columns[key] ? "selected" : "unselected",
            doNotCloseOnClick: true,
            devider: index === orderedKeys.length - 1,
        }));
        // items.push({
        //     id: "columnsSelectDefault",
        //     title: t("Shared.columnsSelectDefault"),
        //     icon: <FontAwesomeIcon icon={faArrowsRotate} />,
        //     doNotCloseOnClick: true,
        // });
        // items.push({
        //     id: "columnsOrderDefault",
        //     title: t("Shared.columnsOrderDefault"),
        //     icon: <FontAwesomeIcon icon={faArrowsRotate} />,
        //     doNotCloseOnClick: true,
        // });
        // items.push({
        //     id: "columnsSizeDefault",
        //     title: t("Shared.columnsSizeDefault"),
        //     icon: <FontAwesomeIcon icon={faArrowsRotate} />,
        //     doNotCloseOnClick: true,
        // });
        // items.push({
        //     id: "columnsSortDefault",
        //     title: t("Shared.columnsSortDefault"),
        //     icon: <FontAwesomeIcon icon={faArrowsRotate} />,
        //     doNotCloseOnClick: true,
        //     devider: true,
        // });
        items.push({
            id: "columnsAllDefault",
            title: t("Shared.columnsAllDefault"),
            icon: <FontAwesomeIcon icon={faArrowsRotate} />,
            doNotCloseOnClick: true,
        });

        return items;
    }, [orderedKeys, props.columns, t]);

    return (
        <div className="userful-table-header-actions-wrapper">
            {props.minimumNumberOfActions > 1 &&
                Array.from({ length: props.minimumNumberOfActions - 1 }, (_, index) => (
                    <div key={index} className="userful-table-header-cell-fixed" />
                ))}
            <div className="userful-table-header-cell-fixed" onClick={(event) => event.stopPropagation()}>
                <Dropdown
                    items={dropdownItems}
                    itemTranslation="Shared"
                    onChange={(item) => {
                        if (item.id === "columnsSelectDefault") {
                            props.onResetColumns?.();
                            return;
                        }
                        if (item.id === "columnsOrderDefault") {
                            props.onResetOrder?.();
                            return;
                        }
                        if (item.id === "columnsSizeDefault") {
                            props.onResetSizes?.();
                            return;
                        }
                        if (item.id === "columnsSortDefault") {
                            props.onResetSort?.();
                            return;
                        }
                        if (item.id === "columnsAllDefault") {
                            props.onResetAll?.();
                            return;
                        }

                        if (!(item.id in props.columns)) {
                            return;
                        }

                        const value = props.columns[item.id];
                        const newColumns = { ...props.columns };
                        newColumns[item.id] = !value;
                        props.onColumnSelectorChange?.(newColumns);
                    }}
                    trigger={
                        <Button
                            className="source-actions-menu-toggle"
                            variant="ghost"
                            size="small"
                            iconOnly
                            style={{ width: 36 }}
                            aria-label={t("Shared.columns")}
                        >
                            <FontAwesomeIcon icon={faSlidersSimple} />
                        </Button>
                    }
                    usePortal
                />
            </div>
        </div>
    );
}
